import { render } from "./BrandPosts.vue?vue&type=template&id=21089561"
import script from "./BrandPosts.vue?vue&type=script&lang=js"
export * from "./BrandPosts.vue?vue&type=script&lang=js"

import "./BrandPosts.vue?vue&type=style&index=0&id=21089561&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__